import lightOrdarkColor from '@check-light-or-dark/color';
import { palette } from '../palette';
import { darken, lighten } from '@mui/material';

const MuiInputBase = {
  defaultProps: {
    inputProps:({theme} : any) => ({
      disableunderline: 'true',
      onFocus: (event: any) => {
        event.target.value = '';
        event.target.style.fontStyle = 'normal';
        event.target.style.color = theme.palette.text.secondary;
      },
    }),
  },
  styleOverrides: {
    root:({theme} : any) => ({
      color: theme.palette.text.secondary,

      '&.Mui-disabled':{
        color: palette.disabledColor.contrastText,
        backgroundColor: lightOrdarkColor(theme.palette.background.default) === 'dark' ? palette.disabledColor.dark : palette.disabledColor.light,
        borderColor:  lightOrdarkColor(theme.palette.background.default) === 'dark' ? lighten(theme.palette.background.default, 0.6) : darken(theme.palette.background.default, 0.2),

        'WebkitTextFillColor': 'initial',
      },
    }),
  },
};

export default MuiInputBase;
